/**
 * 菜单管理 web api
 * @author Risin.Xu
 * @create 2021-03-09 18:24:58
 */
import request from "@/utils/request"
import service from "@/utils/service"

export function moduleType() {
  return [
    {id: 1, label: "系统建模"},
    {id: 2, label: "TCODE"},
    {id: 3, label: "会员管理"},
    {id: 4, label: "知识库"},
  ]
}

export function menuType() {
  return [
    {id: 1, label: "目录"},
    {id: 2, label: "菜单"}
  ]
}

/**
 * 查询菜单管理列表
 */
export function listTree(param) {
  return request({
    url: service.tcode + "/platform/menu/listTree",
    method: "post",
    data: param
  });
}

/**
 * 根据PK删除 菜单管理
 */
export function delData(pk) {
  return request({
    url: service.tcode + "/platform/menu/delete/" + pk,
    method: "get"
  });
}

/**
 * 根据PK查询一个菜单管理
 */
export function get(pk) {
  return request({
    url: service.tcode + "/platform/menu/get/" + pk,
    method: "get"
  });
}

/**
 * 保存菜单管理数据
 */
export function save(data) {
  return request({
    url: service.tcode + "/platform/menu/save",
    method: "post",
    data: data
  });
}


/**
 * 查询菜单管理列表
 * @param param 查询参数
 */
export function list(param) {
  return request({
    url: service.tcode + "/platform/menu/list",
    method: "post",
    data: param
  })
}

/**
 * 查询我的菜单-用户
 * @param pkuser 查询参数
 */
export function listMyMenuTreeByUser(pkuser) {
  return request({
    url: service.tcode + "/platform/menu/listMyMenuTreeByUser/" + pkuser,
    method: "post"
  })
}

/**
 * 根据PK查询一个门店管理
 * @param pks 主键数组
 */

/*export function deleteBatch(pks) {
  return request({
    url: service.tcode +  "/platform/menu/deleteBatch",
    method: "post",
    data: pks
  })
}*/


/**
 * 查询我的菜单
 */
export function listMyMenuTree() {
  return request({
    url: service.tcode + "/platform/menu/listMyMenuTree",
    method: "post"
  })
}



// WEBPACK FOOTER //
// ./src/api/platform/menu.js